// externals
import type { Reducer } from 'redux';
import type { Draft } from 'immer';
import { produce } from 'immer';

// libraries
import type { FeatureToggles } from '@makemydeal/dr-platform-shared';
import type { FeatureToggles as AnyFeatureToggles } from '@makemydeal/dr-feature-toggles-client';

// consts/enums
import { INIT_PENCIL_INVALID_DEAL, INIT_PENCIL_SUCCESS, GET_DETAILS_SUCCESS } from '../actionTypes/initActionTypes';

// interfaces/types
import type { AllFeatureToggleActions } from '../actions/bootstrapSharedActionCreators';
import type { FeatureTogglesAndUrlOnly } from '../types/featureToggleTypes';

export type IFeatureToggleState = FeatureToggles;

export const getFeatureTogglesInitSuccessPayload = (action: AllFeatureToggleActions): Partial<FeatureToggles> => {
    return action.payload?.featureToggles || ({} as Partial<FeatureToggles>);
};

export const getFeatureToggleFromSlice = (
    featureToggleState: IFeatureToggleState,
    name: keyof FeatureTogglesAndUrlOnly
): boolean => {
    return (featureToggleState as AnyFeatureToggles)[name as string] || false;
};

export const isDigitalDealJacketEnabledFromSlice = (featureToggleState: IFeatureToggleState): boolean =>
    getFeatureToggleFromSlice(featureToggleState, 'enableDigitalDealJacket');

export const isPushToDarwinEnabled = (featureToggleState: IFeatureToggleState): boolean =>
    getFeatureToggleFromSlice(featureToggleState, 'enablePushToDarwin');

export const reducer: Reducer<IFeatureToggleState> = (state: IFeatureToggleState = {}, action: AllFeatureToggleActions) => {
    if (!action) {
        return state;
    }
    return produce(state, (draft: Draft<IFeatureToggleState>) => {
        const draftToUse = draft as Draft<AnyFeatureToggles>;
        switch (action.type) {
            case INIT_PENCIL_SUCCESS:
            case INIT_PENCIL_INVALID_DEAL:
            case GET_DETAILS_SUCCESS: {
                const featureToggleNames = Object.keys(getFeatureTogglesInitSuccessPayload(action));
                featureToggleNames.forEach((name) => {
                    draftToUse[name] = (action.payload!.featureToggles as AnyFeatureToggles)[name];
                });
                return;
            }
        }
    });
};
